/* @bend-expect trellis-tokenized */
import { useCallback, useEffect, useMemo, useState } from 'react';
import { getActiveMark, setMarkCommand } from '../utils/markUtils';
import { FONT_STYLES } from '../constants/fontConstants';
import { PM_FORMATTING } from '../constants/events';
import { CHANGE_FONT } from 'rich-text-lib/constants/usageTracking';
import { Tracker } from '../../utils/usageTracker';
import useDebouncedEditorStateContext from '../contexts/useDebouncedEditorStateContext';
import I18n from 'I18n';
import { parseAvailableFont } from '../utils/fontUtils';
import { TextToolbarSelect } from 'rich-text-lib/components/editor/TextToolbarSelect';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
export const setFontStyle = attrs => setMarkCommand(schema => schema.marks.font_style, attrs);
const getAvailableFont = fontStyle => fontStyle && parseAvailableFont(fontStyle) || FONT_STYLES[0].value;
export default function FontStyleMark({
  defaultFontStyle
}) {
  const {
    editorState,
    setEditorState
  } = useDebouncedEditorStateContext();
  const defaultAvailableStyle = useMemo(() => {
    return getAvailableFont(defaultFontStyle);
  }, [defaultFontStyle]);
  const [styleValue, setStyleValue] = useState(defaultAvailableStyle);
  useEffect(() => {
    const activeFontStyle = getActiveMark(editorState, editorState.schema.marks.font_style);
    if (activeFontStyle) {
      setStyleValue(getAvailableFont(activeFontStyle.attrs.style));
    } else {
      setStyleValue(defaultAvailableStyle);
    }
  }, [editorState, setStyleValue, defaultAvailableStyle]);
  const applyFontStyle = useCallback(evt => {
    setFontStyle({
      style: evt.target.value
    })(editorState, tr => {
      const newTr = tr.setMeta('font_style', evt.target.value);
      setEditorState(editorState.apply(newTr));
    });
    setStyleValue(evt.target.value);
    Tracker.track(PM_FORMATTING, {
      action: CHANGE_FONT,
      method: 'toolbar',
      value: evt.target.value
    });
  }, [editorState, setEditorState, setStyleValue]);
  return /*#__PURE__*/_jsx(View, {
    onClick: e => e.stopPropagation(),
    children: /*#__PURE__*/_jsx(TextToolbarSelect, {
      "data-test-id": "font-styles-dropdown",
      onChange: applyFontStyle,
      options: FONT_STYLES,
      value: styleValue,
      placeholder: I18n.text('hubspot-prosemirror.buttons.fontStylePlaceholder'),
      maxInlineSize: "min-content",
      buttonUse: "transparent"
    })
  });
}